import { render, staticRenderFns } from "./Goodsclass.vue?vue&type=template&id=dc9ebd92&scoped=true&"
import script from "./Goodsclass.vue?vue&type=script&lang=js&"
export * from "./Goodsclass.vue?vue&type=script&lang=js&"
import style0 from "./Goodsclass.vue?vue&type=style&index=0&id=dc9ebd92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ebd92",
  null
  
)

export default component.exports